export const COPILOT_STUDIO_NAME = "Copilot Studio"
